import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const RateInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Rate Information</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text style={baseStyles.flex}>
                        Buy Rate
                    </Text>
                    <Text>{pdfData.buy_rate}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>
                        Bump Rate
                    </Text>
                    <Text>{pdfData.bump_rate.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween, ...baseStyles.boldTopBorder}}>
                    <Text>
                        Disclosed Rate
                    </Text>
                    <Text>{pdfData.disclosed_rate}</Text>
                </View>
            </View>
        </View>
    )
}